var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrapper"},[_c('h1',[_vm._v(":(")]),_c('h2',{staticClass:"error-title"},[_vm._v(_vm._s(_vm.titleValue))]),_c('p',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.messageValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }